import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import CookieBanner from '../../components/feature/CookieBanner';

const AboutPage = () => {
  useEffect(() => {
    document.title = 'Hakkımızda - İzmir Vize Danışmanlığı | LH Global Pass';
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20">
        {/* Hero Section */}
        <section className="relative min-h-[60vh] flex items-center justify-center overflow-hidden bg-gradient-to-br from-navy via-navy-light to-navy">
          <div className="absolute inset-0 z-0">
            <img
              src="https://public.readdy.ai/ai/img_res/d3b256e4885cb34e63ffb2488d160279.jpg"
              alt="LH Global Pass Vize Danışmanı"
              className="w-full h-full object-cover object-center opacity-20"
            />
          </div>
          <div className="container mx-auto px-4 lg:px-8 relative z-10 text-center py-20">
            <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6">
              Hakkımızda
            </h1>
            <p className="text-xl text-gray-200 max-w-3xl mx-auto">
              İzmir'in en güvenilir vize danışmanlık firması olarak 12 yıldır hizmetinizdeyiz
            </p>
          </div>
        </section>

        {/* Main Content */}
        <section className="py-20">
          <div className="container mx-auto px-4 lg:px-8">
            <div className="max-w-5xl mx-auto">
              {/* Introduction */}
              <div className="mb-16">
                <h2 className="text-3xl font-bold text-navy mb-6">LH Global Pass Kimdir?</h2>
                <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed space-y-4">
                  <p>
                    <strong>LH Global Pass</strong>, İzmir'de 12 yılı aşkın süredir <strong>vize danışmanlığı</strong> hizmeti sunan, alanında uzman ve güvenilir bir firmadır. Kuruluşumuzdan bu yana binlerce kişinin hayallerini gerçekleştirmesine yardımcı olduk ve uluslararası seyahat süreçlerini kolaylaştırdık.
                  </p>
                  <p>
                    <strong>İzmir vize danışmanlığı</strong> sektöründe öncü konumumuzla, Schengen vizesi, Amerika vizesi, İngiltere vizesi, oturum kartı başvuruları, göçmenlik ve aile birleşimi süreçleri gibi geniş bir yelpazede profesyonel destek sağlıyoruz. Müşterilerimizin ihtiyaçlarını en iyi şekilde anlayarak, her başvuruyu titizlikle hazırlıyor ve sürecin her aşamasında yanlarında oluyoruz.
                  </p>
                </div>
              </div>

              {/* Mission & Vision */}
              <div className="grid md:grid-cols-2 gap-8 mb-16">
                <div className="bg-gradient-to-br from-amber-50 to-orange-50 p-8 rounded-2xl">
                  <div className="w-16 h-16 flex items-center justify-center bg-gold rounded-full mb-6">
                    <i className="ri-compass-3-line text-3xl text-navy"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-navy mb-4">Misyonumuz</h3>
                  <p className="text-gray-700 leading-relaxed">
                    <strong>İzmir vize danışmanlığı</strong> alanında en yüksek kalite standartlarını sunarak, müşterilerimizin uluslararası seyahat ve göçmenlik süreçlerini sorunsuz bir şekilde tamamlamalarını sağlamak. Her müşterimize özel, güvenilir ve hızlı çözümler üreterek, hayallerini gerçekleştirmelerine destek olmak.
                  </p>
                </div>
                <div className="bg-gradient-to-br from-blue-50 to-indigo-50 p-8 rounded-2xl">
                  <div className="w-16 h-16 flex items-center justify-center bg-navy rounded-full mb-6">
                    <i className="ri-eye-line text-3xl text-gold"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-navy mb-4">Vizyonumuz</h3>
                  <p className="text-gray-700 leading-relaxed">
                    Türkiye'nin en güvenilir ve tercih edilen vize danışmanlık firması olmak. Sürekli gelişen teknoloji ve değişen mevzuatlara uyum sağlayarak, müşterilerimize en güncel ve etkili çözümleri sunmak. <strong>İzmir vize danışmanlığı</strong> sektöründe lider konumumuzu pekiştirmek.
                  </p>
                </div>
              </div>

              {/* Why Choose Us */}
              <div className="mb-16">
                <h2 className="text-3xl font-bold text-navy mb-8 text-center">Neden LH Global Pass?</h2>
                <div className="grid md:grid-cols-3 gap-6">
                  <div className="text-center p-6">
                    <div className="w-20 h-20 flex items-center justify-center bg-gold/10 rounded-full mx-auto mb-4">
                      <i className="ri-award-line text-4xl text-gold"></i>
                    </div>
                    <h4 className="text-xl font-semibold text-navy mb-3">12 Yıllık Deneyim</h4>
                    <p className="text-gray-600 text-sm">
                      Sektörde 12 yılı aşkın deneyimimizle, her türlü vize başvurusunda uzman desteği sunuyoruz.
                    </p>
                  </div>
                  <div className="text-center p-6">
                    <div className="w-20 h-20 flex items-center justify-center bg-gold/10 rounded-full mx-auto mb-4">
                      <i className="ri-team-line text-4xl text-gold"></i>
                    </div>
                    <h4 className="text-xl font-semibold text-navy mb-3">Profesyonel Kadro</h4>
                    <p className="text-gray-600 text-sm">
                      Alanında uzman, deneyimli ve sürekli eğitim alan profesyonel danışmanlarımızla hizmetinizdeyiz.
                    </p>
                  </div>
                  <div className="text-center p-6">
                    <div className="w-20 h-20 flex items-center justify-center bg-gold/10 rounded-full mx-auto mb-4">
                      <i className="ri-customer-service-2-line text-4xl text-gold"></i>
                    </div>
                    <h4 className="text-xl font-semibold text-navy mb-3">Müşteri Memnuniyeti</h4>
                    <p className="text-gray-600 text-sm">
                      %98 başarı oranımız ve binlerce mutlu müşterimizle, güvenilir hizmet anlayışımızı sürdürüyoruz.
                    </p>
                  </div>
                </div>
              </div>

              {/* Detailed Content */}
              <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed space-y-6">
                <h3 className="text-2xl font-bold text-navy">Uzmanlık Alanlarımız</h3>
                <p>
                  <strong>İzmir vize danışmanlığı</strong> hizmetlerimiz kapsamında, Schengen bölgesi ülkelerine yönelik C tipi (turistik, ticari, aile ziyareti) ve D tipi (çalışma, eğitim) vize başvurularında tam destek sağlıyoruz. Amerika Birleşik Devletleri için DS-160 form hazırlığından mülakat danışmanlığına kadar tüm süreçleri yönetiyoruz. İngiltere vizesi başvurularında evrak hazırlığı ve dilekçe desteği sunuyoruz.
                </p>
                <p>
                  Ayrıca, AB ülkeleri başta olmak üzere oturum kartı başvuruları, aile birleşimi süreçleri, evlilik ve kalıcı göçmenlik başvurularında hukuki süreç yönetimi konusunda uzmanız. Dubai, Ermenistan, Kuveyt, Suudi Arabistan, Rusya, Vietnam, Küba gibi ülkeler için e-vize hizmetleri de sunmaktayız.
                </p>

                <h3 className="text-2xl font-bold text-navy">Çalışma Prensiplerimiz</h3>
                <p>
                  LH Global Pass olarak, müşteri memnuniyetini her zaman ön planda tutuyoruz. Her başvuruyu özenle inceliyor, eksik evrak ve hatalı bilgilerin önüne geçiyoruz. Sürecin her aşamasında müşterilerimizi bilgilendiriyor, şeffaf bir iletişim anlayışıyla çalışıyoruz.
                </p>
                <p>
                  <strong>İzmir vize danışmanlığı</strong> sektöründeki güncel gelişmeleri yakından takip ediyor, değişen mevzuatlara anında uyum sağlıyoruz. Müşterilerimize en doğru ve güncel bilgileri sunarak, başvuru süreçlerinin sorunsuz ilerlemesini garanti ediyoruz.
                </p>

                <h3 className="text-2xl font-bold text-navy">Başarı Hikayelerimiz</h3>
                <p>
                  12 yıllık süreçte 5000'den fazla başarılı vize başvurusu gerçekleştirdik. Müşterilerimizin %98'i vize onayı aldı ve hayallerindeki ülkelere seyahat etme fırsatı yakaladı. Her başarılı başvuru, bizim için yeni bir motivasyon kaynağı ve gurur vesilesidir.
                </p>
                <p>
                  Öğrencilerden iş insanlarına, ailelerden bireysel gezginlere kadar geniş bir kitleye hizmet verdik. Her müşterimizin hikayesi bizim için değerlidir ve onların mutluluğu, işimizin en büyük ödülüdür.
                </p>

                <h3 className="text-2xl font-bold text-navy">İletişim ve Erişilebilirlik</h3>
                <p>
                  İzmir Konak'ta bulunan ofisimizde, hafta içi her gün müşterilerimize hizmet veriyoruz. Randevu sistemiyle çalışarak, her müşterimize yeterli zaman ayırıyor ve detaylı bilgilendirme yapıyoruz. WhatsApp hattımız ve telefon numaramız üzerinden 7/24 iletişime geçebilir, sorularınızı sorabilirsiniz.
                </p>
                <p>
                  <strong>İzmir vize danışmanlığı</strong> alanında güvenilir bir partner arıyorsanız, LH Global Pass tam size göre. Hayalinizdeki seyahati gerçekleştirmek için bizimle iletişime geçin, profesyonel ekibimiz sizin için en iyi çözümü üretsin.
                </p>
              </div>

              {/* CTA Section */}
              <div className="mt-16 bg-gradient-to-r from-navy to-navy-light text-white p-12 rounded-3xl text-center">
                <h3 className="text-3xl font-bold mb-4">Hayalinizdeki Seyahat İçin Hemen Başlayın</h3>
                <p className="text-gray-200 mb-8 max-w-2xl mx-auto">
                  12 yıllık deneyimimiz ve profesyonel ekibimizle vize sürecinizi kolaylaştırıyoruz. Hemen iletişime geçin!
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <a
                    href="https://wa.me/905422671171?text=Merhaba%20ben%20lhglobalpass.com%20%C3%BCzerinden%20ileti%C5%9Fime%20ge%C3%A7iyorum"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-gold hover:bg-gold-dark text-navy px-8 py-4 rounded-full text-base font-semibold transition-all duration-300 hover:shadow-lg inline-flex items-center justify-center gap-2 whitespace-nowrap"
                  >
                    <i className="ri-whatsapp-line text-xl"></i>
                    WhatsApp ile İletişim
                  </a>
                  <a
                    href="tel:+905422671171"
                    className="bg-transparent border-2 border-white hover:bg-white text-white hover:text-navy px-8 py-4 rounded-full text-base font-semibold transition-all duration-300 hover:shadow-lg inline-flex items-center justify-center gap-2 whitespace-nowrap"
                  >
                    <i className="ri-phone-line text-xl"></i>
                    Hemen Ara
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppButton />
      <CookieBanner />
    </div>
  );
};

export default AboutPage;
